(() => {
  'use strict';

  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
  const abortableDelay = (ms, signal) => new Promise((resolve, reject) => {
    const abortError = () => {
      const error = new Error('Aborted');
      error.name = 'AbortError';
      return error;
    };
    if (signal?.aborted) {
      reject(abortError());
      return;
    }
    const timer = window.setTimeout(resolve, ms);
    signal?.addEventListener('abort', () => {
      window.clearTimeout(timer);
      reject(abortError());
    }, { once: true });
  });
  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);
  const locale = document.documentElement.lang || 'pt-BR';

  // Formato de moeda configurado na loja. Sem isso, preco vindo do Liquid (| money)
  // e preco atualizado por JS divergiam na mesma tela.
  const MONEY_FORMAT = String(window.DropMetaTheme?.moneyFormat || '').replace(/<[^>]*>/g, '').trim();

  function groupDigits(value, decimals, thousandsMark, decimalMark) {
    const fixed = Math.abs(value).toFixed(decimals);
    const parts = fixed.split('.');
    const integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsMark);
    return parts[1] ? integer + decimalMark + parts[1] : integer;
  }

  function formatMoney(cents, currency = 'BRL') {
    const value = (Number(cents) || 0) / 100;
    const placeholder = MONEY_FORMAT.match(/\{\{\s*(\w+)\s*\}\}/);

    if (placeholder) {
      let amount = null;
      switch (placeholder[1]) {
        case 'amount': amount = groupDigits(value, 2, ',', '.'); break;
        case 'amount_no_decimals': amount = groupDigits(value, 0, ',', ''); break;
        case 'amount_with_comma_separator': amount = groupDigits(value, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': amount = groupDigits(value, 0, '.', ''); break;
        case 'amount_with_apostrophe_separator': amount = groupDigits(value, 2, "'", '.'); break;
        case 'amount_with_space_separator': amount = groupDigits(value, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': amount = groupDigits(value, 0, ' ', ''); break;
        case 'amount_with_period_and_space_separator': amount = groupDigits(value, 2, ' ', '.'); break;
        default: amount = null;
      }
      if (amount !== null) return MONEY_FORMAT.replace(/\{\{\s*\w+\s*\}\}/, amount);
    }

    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value);
    } catch (_) {
      return `R$ ${value.toFixed(2).replace('.', ',')}`;
    }
  }

  function syncBodyLock() {
    const open = document.querySelector('.drawer.is-open, .bag.is-open, .filterSheet.is-open, .brand-searchShell.is-open');
    document.body.classList.toggle('is-locked', Boolean(open));
  }

  function initAnnouncementRotator() {
    const inner = $('[data-announcement-rotator]');
    if (!inner) return;

    const items = $$('.brand-announcement__item', inner);
    if (items.length < 2) return;

    const media = window.matchMedia('(max-width: 620px)');
    let activeIndex = 0;
    let timer;

    const setActive = (nextIndex) => {
      activeIndex = nextIndex;
      items.forEach((item, index) => {
        const isActive = media.matches && index === activeIndex;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-hidden', media.matches && !isActive ? 'true' : 'false');
      });
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (!media.matches) {
        items.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-hidden', 'false');
        });
        return;
      }

      setActive(activeIndex % items.length);
      timer = window.setInterval(() => setActive((activeIndex + 1) % items.length), 3600);
    };

    media.addEventListener?.('change', start);
    start();
  }

  const recentProductsKey = 'sua-marca-recent-products';

  function getRecentProducts() {
    try {
      const stored = JSON.parse(localStorage.getItem(recentProductsKey) || '[]');
      return Array.isArray(stored) ? stored : [];
    } catch (_) {
      return [];
    }
  }

  function setRecentProducts(products) {
    try {
      localStorage.setItem(recentProductsKey, JSON.stringify(products));
    } catch (_) {}
  }

  function rememberRecentProduct(product) {
    if (!product?.id || !product?.url || !product?.title) return;
    const current = getRecentProducts().filter((item) => String(item.id) !== String(product.id));
    current.unshift(product);
    setRecentProducts(current.slice(0, 8));
  }

  function renderHeaderSearchCards(products = []) {
    return products.map((product) => {
      const image = product.image
        ? `<img class="brand-searchCard__image" src="${escapeHTML(product.image)}" alt="${escapeHTML(product.title)}" loading="lazy">`
        : '';
      const compare = Number(product.comparePrice) > Number(product.price)
        ? `<s>${formatMoney(product.comparePrice, window.DropMetaTheme.currency || 'BRL')}</s>`
        : '';
      return `<article class="brand-searchCard">
        <a class="brand-searchCard__media" href="${escapeHTML(product.url)}">${image}</a>
        <div class="brand-searchCard__body">
          <a class="brand-searchCard__title" href="${escapeHTML(product.url)}">${escapeHTML(product.title)}</a>
          <div class="brand-searchCard__price">${compare}<span>${formatMoney(product.price, window.DropMetaTheme.currency || 'BRL')}</span></div>
        </div>
      </article>`;
    }).join('');
  }

  function openPanel(panel, scrim, trigger) {
    if (!panel) return;
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
      panel._returnFocus = trigger;
    }
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (scrim) {
      scrim.hidden = false;
      requestAnimationFrame(() => scrim.classList.add('is-open'));
    }
    if (panel.hasAttribute('data-menu-drawer')) {
      requestAnimationFrame(() => {
        const focusTarget = $('[data-drawer-close]', panel) || panel;
        focusTarget.focus({ preventScroll: true });
      });
    }
    syncBodyLock();
  }

  function closePanel(panel, scrim, returnFocus = panel?._returnFocus) {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if (returnFocus) {
      returnFocus.setAttribute('aria-expanded', 'false');
      if (document.contains(returnFocus)) returnFocus.focus({ preventScroll: true });
    }
    panel._returnFocus = null;
    if (scrim) {
      scrim.classList.remove('is-open');
      window.setTimeout(() => { if (!scrim.classList.contains('is-open')) scrim.hidden = true; }, 260);
    }
    syncBodyLock();
  }

  function initHeader() {
    const header = $('[data-header]');
    if (header) {
      const onScroll = () => header.dataset.scrolled = window.scrollY > 8 ? 'true' : 'false';
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    const searchShell = $('[data-search-shell]');
    const searchForm = $('[data-search-form]', searchShell || document);
    const searchInput = $('[data-search-input]', searchShell || document);
    const searchResults = $('[data-search-results]', searchShell || document);
    const searchResultsContent = $('[data-search-results-content]', searchShell || document);
    const searchResultsTitle = $('[data-search-results-title]', searchShell || document);
    const searchResultsLink = $('[data-search-results-link]', searchShell || document);
    const searchDefault = $('[data-search-default]', searchShell || document);
    const searchScrim = $('[data-search-scrim]');
    const searchRecentSection = $('[data-search-recent-section]', searchShell || document);
    const searchRecentGrid = $('[data-search-recent-grid]', searchShell || document);
    let predictiveTimer;
    let predictiveRequest;
    // Sequencia das requisicoes: garante que apenas a resposta do termo atual pinte a UI.
    let predictiveToken = 0;
    // Ultimo termo processado, para nao refazer a mesma requisicao (ex.: espaco no fim).
    let predictiveLastQuery = '';
    // Cache por termo: apagar/redigitar caracteres nao gera nova ida ao servidor.
    const predictiveCache = new Map();
    const PREDICTIVE_CACHE_LIMIT = 40;
    const PREDICTIVE_DEBOUNCE = 300;
    // Campos consultados. Os 4 primeiros sao o conjunto padrao da API; tag e variants.sku
    // sao acrescentados para que termos completos que vivem em tag/SKU tambem casem.
    const PREDICTIVE_FIELDS = 'title,product_type,variants.title,vendor,tag,variants.sku';
    const PREDICTIVE_ERROR_HTML = '<div class="brand-searchEmpty"><p class="t-body t-mute">Nao foi possivel carregar os resultados agora.</p></div>';

    const renderRecentProducts = () => {
      if (!searchRecentSection || !searchRecentGrid) return;
      const items = getRecentProducts();
      if (!items.length) {
        searchRecentSection.hidden = true;
        searchRecentGrid.innerHTML = '';
        return;
      }
      searchRecentSection.hidden = false;
      searchRecentGrid.innerHTML = renderHeaderSearchCards(items.slice(0, 4));
    };

    const showDefaultSearch = () => {
      if (searchDefault) searchDefault.hidden = false;
      if (searchResults) searchResults.hidden = true;
      if (searchResultsContent) searchResultsContent.innerHTML = '';
      if (searchResultsLink) searchResultsLink.hidden = true;
      renderRecentProducts();
    };

    const openSearch = () => {
      if (!searchShell || !searchForm) return;
      searchShell.hidden = false;
      requestAnimationFrame(() => {
        searchShell.classList.add('is-open');
        syncBodyLock();
      });
      $$('[data-search-open]').forEach((button) => button.setAttribute('aria-expanded', 'true'));
      if (searchScrim) {
        searchScrim.hidden = false;
        requestAnimationFrame(() => searchScrim.classList.add('is-open'));
      }
      showDefaultSearch();
      window.setTimeout(() => searchInput?.focus(), 40);
    };
    const closeSearch = () => {
      if (!searchShell) return;
      window.clearTimeout(predictiveTimer);
      predictiveToken += 1;
      predictiveLastQuery = '';
      if (predictiveRequest) predictiveRequest.abort();
      searchShell.classList.remove('is-open');
      if (searchScrim) {
        searchScrim.classList.remove('is-open');
        window.setTimeout(() => { if (!searchScrim.classList.contains('is-open')) searchScrim.hidden = true; }, 220);
      }
      $$('[data-search-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
      window.setTimeout(() => {
        if (!searchShell.classList.contains('is-open')) searchShell.hidden = true;
      }, 220);
      if (searchInput) searchInput.value = '';
      showDefaultSearch();
      syncBodyLock();
    };
    const buildPredictiveEndpoint = (query) => [
      `${window.DropMetaTheme.routes.search}/suggest`,
      '?section_id=predictive-search',
      '&resources[type]=product',
      '&resources[limit]=10',
      '&resources[limit_scope]=each',
      '&resources[options][unavailable_products]=last',
      `&resources[options][fields]=${PREDICTIVE_FIELDS}`,
      `&q=${encodeURIComponent(query)}`
    ].join('');

    // Abre o bloco de resultados sem depender de uma resposta de rede.
    const openPredictiveShell = (query) => {
      searchDefault.hidden = true;
      searchResults.hidden = false;
      if (searchResultsTitle) searchResultsTitle.textContent = `Resultados para "${query}"`;
      if (searchResultsLink) {
        searchResultsLink.hidden = false;
        searchResultsLink.href = `${window.DropMetaTheme.routes.search}?type=product&q=${encodeURIComponent(query)}`;
      }
    };

    const isPredictiveCurrent = (query, token) => {
      if (token !== predictiveToken) return false;
      if (searchInput && searchInput.value.trim() !== query) return false;
      return true;
    };

    const renderPredictiveMarkup = (query, markup, token) => {
      if (!isPredictiveCurrent(query, token)) return;
      const holder = document.createElement('div');
      holder.innerHTML = markup;
      const root = $('[data-predictive-search-root]', holder);
      openPredictiveShell(query);
      // Sem root a secao nao renderizou (404/417/422, secao ausente). Isso e falha,
      // nao "zero resultados" -- o estado vazio real vem dentro do root.
      if (!root) {
        console.warn('[predictive-search] resposta sem [data-predictive-search-root] para', query);
        searchResultsContent.innerHTML = PREDICTIVE_ERROR_HTML;
        return;
      }
      searchResultsContent.innerHTML = root.innerHTML;
    };

    const cachePredictiveMarkup = (query, markup) => {
      predictiveCache.set(query, markup);
      if (predictiveCache.size > PREDICTIVE_CACHE_LIMIT) {
        predictiveCache.delete(predictiveCache.keys().next().value);
      }
    };

    const loadPredictiveResults = async (query) => {
      if (!searchResults || !searchResultsContent || !searchDefault) return;

      const token = ++predictiveToken;

      if (predictiveCache.has(query)) {
        renderPredictiveMarkup(query, predictiveCache.get(query), token);
        return;
      }

      if (predictiveRequest) predictiveRequest.abort();
      predictiveRequest = new AbortController();
      const signal = predictiveRequest.signal;
      const endpoint = buildPredictiveEndpoint(query);

      try {
        let response = await fetch(endpoint, { signal });
        // 429: a API tem limite de taxa. Ao digitar rapido o ultimo termo (o completo)
        // e justamente o mais propenso a ser barrado, entao respeitamos Retry-After.
        if (response.status === 429) {
          const retryAfter = clamp(Number(response.headers.get('Retry-After')) || 1, 1, 3);
          await abortableDelay(retryAfter * 1000, signal);
          response = await fetch(endpoint, { signal });
        }
        if (!response.ok) throw new Error(`Predictive search HTTP ${response.status}`);
        const markup = await response.text();
        cachePredictiveMarkup(query, markup);
        renderPredictiveMarkup(query, markup, token);
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (!isPredictiveCurrent(query, token)) return;
        console.warn('[predictive-search]', error);
        openPredictiveShell(query);
        searchResultsContent.innerHTML = PREDICTIVE_ERROR_HTML;
      }
    };

    $$('[data-search-open]').forEach((button) => button.addEventListener('click', openSearch));
    $('[data-search-close]', searchShell || document)?.addEventListener('click', closeSearch);
    searchScrim?.addEventListener('click', closeSearch);
    $('[data-search-recent-clear]', searchShell || document)?.addEventListener('click', () => {
      setRecentProducts([]);
      renderRecentProducts();
    });
    searchInput?.addEventListener('input', () => {
      const query = searchInput.value.trim();
      // Termo efetivo nao mudou (ex.: espaco no fim): nao cancela o trabalho ja agendado.
      if (query === predictiveLastQuery) return;
      predictiveLastQuery = query;
      window.clearTimeout(predictiveTimer);
      if (query.length < 2) {
        predictiveToken += 1;
        if (predictiveRequest) predictiveRequest.abort();
        showDefaultSearch();
        return;
      }
      predictiveTimer = window.setTimeout(() => loadPredictiveResults(query), PREDICTIVE_DEBOUNCE);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeSearch();
    });

    const menu = $('[data-menu-drawer]');
    const scrim = $('[data-drawer-scrim]');
    $$('[data-drawer-open="menu"]').forEach((button) => button.addEventListener('click', () => openPanel(menu, scrim, button)));
    $$('[data-drawer-close]', menu || document).forEach((button) => button.addEventListener('click', () => closePanel(menu, scrim)));
    scrim?.addEventListener('click', () => closePanel(menu, scrim));
  }

  function initRails(scope = document) {
    $$('.rail', scope).forEach((rail) => {
      if (rail.dataset.railReady) return;
      rail.dataset.railReady = 'true';
      const track = $('[data-rail-track]', rail);
      if (!track) return;
      const previousButton = $('[data-rail-prev]', rail);
      const nextButton = $('[data-rail-next]', rail);
      const amount = () => Math.max(track.clientWidth * 0.78, 260);
      const updateControls = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        if (previousButton) previousButton.disabled = track.scrollLeft <= 2;
        if (nextButton) nextButton.disabled = track.scrollLeft >= maxScroll - 2;
      };
      previousButton?.addEventListener('click', () => track.scrollBy({ left: -amount(), behavior: 'smooth' }));
      nextButton?.addEventListener('click', () => track.scrollBy({ left: amount(), behavior: 'smooth' }));
      track.addEventListener('scroll', updateControls, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(updateControls).observe(track);
      else window.addEventListener('resize', updateControls, { passive: true });

      const dragThreshold = 6;
      const clickSuppressDelay = 80;
      let down = false, dragging = false, suppressClick = false, startX = 0, scrollLeft = 0;
      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        down = true; dragging = false; startX = event.clientX; scrollLeft = track.scrollLeft;
      });
      track.addEventListener('pointermove', (event) => {
        if (!down) return;
        const delta = event.clientX - startX;
        if (!dragging && Math.abs(delta) > dragThreshold) {
          dragging = true;
          track.classList.add('is-dragging');
          track.setPointerCapture?.(event.pointerId);
        }
        if (!dragging) return;
        event.preventDefault();
        track.scrollLeft = scrollLeft - delta;
      });
      const end = (event) => {
        if (dragging) {
          suppressClick = true;
          window.setTimeout(() => { suppressClick = false; }, clickSuppressDelay);
        }
        down = false; dragging = false; track.classList.remove('is-dragging');
        if (event?.pointerId && track.hasPointerCapture?.(event.pointerId)) track.releasePointerCapture?.(event.pointerId);
      };
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      track.addEventListener('click', (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
      updateControls();
    });
  }

  const favoritesKey = 'drop-meta-performance-favorites';
  function getFavorites() {
    try { return JSON.parse(localStorage.getItem(favoritesKey) || '[]'); } catch (_) { return []; }
  }
  function initFavorites(scope = document) {
    const current = new Set(getFavorites());
    $$('[data-favorite]', scope).forEach((button) => {
      const handle = button.dataset.favorite;
      button.classList.toggle('is-on', current.has(handle));
      button.addEventListener('click', () => {
        const next = new Set(getFavorites());
        next.has(handle) ? next.delete(handle) : next.add(handle);
        localStorage.setItem(favoritesKey, JSON.stringify(Array.from(next)));
        $$(`[data-favorite="${handle}"]`).forEach((node) => node.classList.toggle('is-on', next.has(handle)));
      });
    });
  }

  function initFeaturedProductFilters(scope = document) {
    $$('[data-featured-products]', scope).forEach((section) => {
      if (section.dataset.featuredFiltersReady === 'true') return;
      const buttons = $$('[data-featured-filter]', section);
      const panels = $$('[data-featured-panel]', section);
      const cta = $('[data-featured-cta]', section);
      if (!buttons.length || !panels.length) return;

      section.dataset.featuredFiltersReady = 'true';
      const firstValue = buttons[0].dataset.featuredFilter;

      const activate = (requestedValue = firstValue) => {
        const hasPanel = panels.some((panel) => panel.dataset.featuredPanel === requestedValue);
        const activeValue = hasPanel ? requestedValue : firstValue;

        panels.forEach((panel) => {
          const isActive = panel.dataset.featuredPanel === activeValue;
          panel.hidden = !isActive;
          panel.setAttribute('aria-hidden', String(!isActive));
        });

        buttons.forEach((button) => {
          const isActive = button.dataset.featuredFilter === activeValue;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });

        const activeButton = buttons.find((button) => button.dataset.featuredFilter === activeValue);
        if (cta && activeButton?.dataset.featuredUrl) cta.href = activeButton.dataset.featuredUrl;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => activate(button.dataset.featuredFilter));
      });
      activate(buttons.find((button) => button.classList.contains('is-active'))?.dataset.featuredFilter);
    });
  }

  const cartDrawer = $('[data-cart-drawer]');
  const cartScrim = $('[data-cart-scrim]');
  const cartMode = window.DropMetaTheme?.cartMode || 'drawer';
  const useCartDrawer = cartMode === 'drawer';
  const CART_SECTION = 'cart-drawer';
  // Locale-aware: em loja multi-idioma a raiz pode ser /pt-br/ em vez de /
  const cartRootUrl = () => window.Shopify?.routes?.root || '/';

  function openCart() {
    if (!useCartDrawer || !cartDrawer) {
      window.location.href = window.DropMetaTheme.routes.cart;
      return;
    }
    refreshCart().finally(() => openPanel(cartDrawer, cartScrim));
  }
  function closeCart() { closePanel(cartDrawer, cartScrim); }

  async function addToCart(payload) {
    let body;
    if (payload instanceof FormData) {
      body = payload;
      body.append('sections', CART_SECTION);
    } else {
      body = new URLSearchParams({ id: payload.id, quantity: payload.quantity || 1, sections: CART_SECTION });
    }

    const response = await fetch(window.DropMetaTheme.routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.description || 'Não foi possível adicionar o produto.');

    if (useCartDrawer && cartDrawer) {
      if (!applyCartSection(data.sections?.[CART_SECTION])) await refreshCart();
      else notifyCartUpdated('add', data);
      openPanel(cartDrawer, cartScrim);
      return;
    }

    window.location.href = window.DropMetaTheme.routes.cart;
  }

  async function changeCart(line, quantity) {
    const response = await fetch(window.DropMetaTheme.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: CART_SECTION })
    });
    if (!response.ok) throw new Error('Não foi possível atualizar o carrinho.');
    const data = await response.json();
    if (!applyCartSection(data.sections?.[CART_SECTION])) await refreshCart();
    else notifyCartUpdated('change', data);
  }

  // Busca a secao renderizada pelo servidor. Usada quando a resposta do carrinho
  // nao trouxe a secao (ex.: falha de render) ou ao abrir o drawer.
  async function refreshCart() {
    const url = `${cartRootUrl()}?sections=${CART_SECTION}`;
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) return false;
    const data = await response.json().catch(() => ({}));
    const applied = applyCartSection(data?.[CART_SECTION]);
    if (applied) notifyCartUpdated('refresh');
    return applied;
  }

  // Troca as regioes do drawer pelo HTML que o servidor renderizou. Como o conteudo
  // vem do Liquid da secao, tudo que um app injetar ali (brinde, barra de frete,
  // plano de assinatura, line item properties) aparece sem o tema precisar conhecer.
  function applyCartSection(html) {
    if (!html) return false;
    const current = $('[data-cart-drawer]');
    if (!current) return false;

    const holder = document.createElement('div');
    holder.innerHTML = html;
    const incoming = holder.querySelector('[data-cart-drawer]') || holder;

    ['[data-shipping-message]', '[data-swr-cart-progress]', '[data-cart-drawer-body]', '[data-cart-drawer-footer]'].forEach((selector) => {
      const next = incoming.querySelector(selector);
      const previous = current.querySelector(selector);
      if (next && previous) previous.replaceWith(next);
    });

    const nextCount = incoming.querySelector('[data-cart-drawer-count]');
    const previousCount = current.querySelector('[data-cart-drawer-count]');
    if (nextCount && previousCount) previousCount.textContent = nextCount.textContent;

    if (nextCount) {
      const parsed = Number(String(nextCount.textContent).trim());
      if (!Number.isNaN(parsed)) syncCartCount(parsed);
    }
    return true;
  }

  // O contador do header nao faz parte da secao do carrinho, entao e sincronizado aqui.
  function syncCartCount(count) {
    $$('[data-cart-count]').forEach((node) => {
      node.textContent = count;
      node.classList.toggle('is-empty', count === 0);
    });
  }

  // Evento publico para apps de terceiros reagirem a mudancas no carrinho.
  function notifyCartUpdated(source, cart = null) {
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source, cart } }));
  }

  window.SWRThemeCart = {
    async applySectionAndOpen(html, source = 'external', cart = null) {
      if (!useCartDrawer || !cartDrawer) return false;

      const applied = applyCartSection(html);
      if (!applied) {
        if (!await refreshCart()) return false;
      } else {
        notifyCartUpdated(source, cart);
      }

      openPanel(cartDrawer, cartScrim);
      return true;
    }
  };

  function initCart() {
    $$('[data-cart-open]').forEach((button) => button.addEventListener('click', openCart));
    cartScrim?.addEventListener('click', closeCart);

    document.addEventListener('click', async (event) => {
      // Delegado: o rodape do drawer e substituido pelo servidor, entao um listener
      // ligado direto no botao seria perdido a cada atualizacao do carrinho.
      if (event.target.closest('[data-cart-close]')) {
        closeCart();
        return;
      }
      const quick = event.target.closest('[data-quick-add]');
      if (quick) {
        quick.disabled = true;
        try { await addToCart({ id: quick.dataset.quickAdd, quantity: 1 }); }
        catch (error) { alert(error.message); }
        finally { quick.disabled = false; }
        return;
      }
      const qty = event.target.closest('[data-cart-qty]');
      if (qty) {
        qty.disabled = true;
        try { await changeCart(qty.dataset.cartQty, qty.dataset.quantity); }
        catch (error) { alert(error.message); }
      }
    });
  }

  function initCollection() {
    const root = $('[data-collection]');
    const layout = $('[data-plp-body]');
    const sidebar = $('[data-filter-sidebar]');
    const filterToggle = $('[data-filter-toggle]');
    const filterToggleLabel = $('[data-filter-toggle-label]');
    const viewButtons = $$('[data-view-option]', root || document);

    filterToggle?.addEventListener('click', () => {
      if (!layout || !sidebar) return;
      const hidden = sidebar.classList.toggle('is-collapsed');
      layout.classList.toggle('plp__layout--full', hidden);
      filterToggle.setAttribute('aria-pressed', hidden ? 'true' : 'false');
      if (filterToggleLabel) filterToggleLabel.textContent = hidden ? 'Mostrar filtros' : 'Ocultar filtros';
    });

    const setCollectionView = (view) => {
      if (!root || !['large', 'compact'].includes(view)) return;
      root.dataset.view = view;
      viewButtons.forEach((button) => {
        const active = button.dataset.viewOption === view;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    if (root && viewButtons.length) {
      setCollectionView(root.dataset.view || 'large');
      viewButtons.forEach((button) => button.addEventListener('click', () => setCollectionView(button.dataset.viewOption)));
    }

    const sortDetails = $('[data-sort-details]');
    document.addEventListener('click', (event) => {
      if (sortDetails?.open && !sortDetails.contains(event.target)) sortDetails.removeAttribute('open');
    });

    sortDetails?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        sortDetails.removeAttribute('open');
        sortDetails.querySelector('summary')?.focus();
      }
    });

    const drawer = $('[data-filter-drawer]');
    const scrim = $('[data-filter-scrim]');
    const filterSource = $('[data-filter-source]');
    const mobileFilterBody = $('[data-filter-mobile-body]', drawer || document);

    const prepareMobileFilters = () => {
      if (!filterSource || !mobileFilterBody || mobileFilterBody.children.length) return;
      const mobileForm = filterSource.cloneNode(true);
      mobileForm.removeAttribute('data-filter-source');
      $$('[id]', mobileForm).forEach((element) => {
        element.id = element.id.replace('Filter-desktop-', 'Filter-mobile-');
      });
      $$('label[for]', mobileForm).forEach((label) => {
        label.htmlFor = label.htmlFor.replace('Filter-desktop-', 'Filter-mobile-');
      });
      mobileFilterBody.appendChild(mobileForm);
    };

    $('[data-filter-open]')?.addEventListener('click', () => {
      prepareMobileFilters();
      openPanel(drawer, scrim);
    });
    $('[data-filter-close]')?.addEventListener('click', () => closePanel(drawer, scrim));
    scrim?.addEventListener('click', () => closePanel(drawer, scrim));
  }

  function initGallery(root) {
    const gallery = $('[data-gallery]', root);
    if (!gallery) return;
    const show = (index) => {
      $$('[data-gallery-slide]', gallery).forEach((slide) => slide.classList.toggle('is-active', Number(slide.dataset.gallerySlide) === Number(index)));
      $$('[data-gallery-thumb]', gallery).forEach((thumb) => thumb.classList.toggle('is-active', Number(thumb.dataset.galleryThumb) === Number(index)));
    };
    $$('[data-gallery-thumb]', gallery).forEach((button) => button.addEventListener('click', () => show(button.dataset.galleryThumb)));
    gallery.showMedia = (mediaId) => {
      const slide = $$('[data-gallery-slide]', gallery).find((node) => String(node.dataset.mediaId) === String(mediaId));
      if (slide) show(slide.dataset.gallerySlide);
    };
  }

  function initProduct() {
    const root = $('[data-product-root]');
    if (!root) return;
    rememberRecentProduct({
      id: root.dataset.productId,
      url: root.dataset.productUrl,
      title: root.dataset.productTitle,
      image: root.dataset.productImage,
      price: Number(root.dataset.productPrice || 0),
      comparePrice: Number(root.dataset.productComparePrice || 0)
    });
    initGallery(root);

    const form = $('[data-product-form]', root);
    const variantsNode = $('[data-product-variants]', root);
    if (!form || !variantsNode) return;

    let variants = [];
    try { variants = JSON.parse(variantsNode.textContent); } catch (_) { return; }

    const selected = {};
    let activeVariant = null;

    $$('.product-option', form).forEach((group) => {
      const active = $('[data-option-value].is-active', group);
      if (active) selected[group.dataset.optionPosition] = active.dataset.optionValue;

      $$('[data-option-value]', group).forEach((button) => button.addEventListener('click', () => {
        $$('[data-option-value]', group).forEach((item) => {
          const isSelected = item === button;
          item.classList.toggle('is-active', isSelected);
          item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
        selected[group.dataset.optionPosition] = button.dataset.optionValue;
        const label = $(`[data-option-label="${group.dataset.optionPosition}"]`, form);
        if (label) label.textContent = button.dataset.optionValue;
        updateVariant();
      }));
    });

    const quantityInput = $('[data-quantity-input]', form);
    const normalizeQuantity = () => {
      if (!quantityInput) return 1;
      const min = Number(quantityInput.min || 1);
      const max = quantityInput.max ? Number(quantityInput.max) : Number.MAX_SAFE_INTEGER;
      const quantity = clamp(Math.round(Number(quantityInput.value) || min), min, max);
      quantityInput.value = quantity;
      return quantity;
    };
    $('[data-quantity-minus]', form)?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = normalizeQuantity() - 1;
      normalizeQuantity();
      updateStickySummary();
    });
    $('[data-quantity-plus]', form)?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = normalizeQuantity() + 1;
      normalizeQuantity();
      updateStickySummary();
    });
    quantityInput?.addEventListener('change', () => {
      normalizeQuantity();
      updateStickySummary();
    });

    // ---- Section Rendering por variante ----------------------------------
    // O JS abaixo continua atualizando preco e botao para dar resposta imediata,
    // mas a fonte da verdade passa a ser o servidor: pedimos a secao renderizada
    // com ?variant=ID&section_id=ID e trocamos as regioes de exibicao. E isso que
    // faz o conteudo por variante dos blocos de app ficar correto, e o preco usar
    // o filtro | money da loja em vez de formatacao do navegador.
    const productUrl = root.dataset.productUrl;
    const sectionId = root.dataset.sectionId;
    let variantRequest = null;
    let variantTimer;
    let lastVariantFetched = $('[data-variant-id]', form)?.value || null;

    const runScripts = (scope) => {
      $$('script', scope).forEach((old) => {
        const script = document.createElement('script');
        Array.from(old.attributes).forEach((attr) => script.setAttribute(attr.name, attr.value));
        script.textContent = old.textContent;
        old.replaceWith(script);
      });
    };

    const swapRegion = (incoming, selector) => {
      const next = incoming.querySelector(selector);
      const previous = root.querySelector(selector);
      if (next && previous) previous.replaceWith(next);
    };

    const applyVariantSection = (html) => {
      const holder = document.createElement('div');
      holder.innerHTML = html;
      const incoming = holder.querySelector('[data-product-root]');
      if (!incoming) return;

      swapRegion(incoming, '[data-price-wrapper]');
      swapRegion(incoming, '.buy__installments');
      swapRegion(incoming, '[data-product-sku-row]');

      const nextLabel = incoming.querySelector('[data-add-label]');
      const previousLabel = root.querySelector('[data-add-label]');
      if (nextLabel && previousLabel) previousLabel.textContent = nextLabel.textContent;

      // Selo da galeria depende da variante (Oferta) e pode nao existir nos dois lados.
      const nextBadge = incoming.querySelector('.gallery__badge');
      const previousBadge = root.querySelector('.gallery__badge');
      const stage = root.querySelector('[data-gallery-stage]');
      if (nextBadge && previousBadge) previousBadge.replaceWith(nextBadge);
      else if (nextBadge && stage) stage.appendChild(nextBadge);
      else if (!nextBadge && previousBadge) previousBadge.remove();

      // Blocos de app: so troca quando o conteudo mudou de fato, para nao derrubar
      // o JS do app sem necessidade. Scripts inline sao reexecutados na troca.
      const nextBlocks = $$('.product-app-block', incoming);
      const previousBlocks = $$('.product-app-block', root);
      if (nextBlocks.length === previousBlocks.length) {
        previousBlocks.forEach((element, index) => {
          if (element.innerHTML.trim() === nextBlocks[index].innerHTML.trim()) return;
          element.replaceWith(nextBlocks[index]);
          runScripts(nextBlocks[index]);
        });
      }

      // Alimenta o "visto recentemente" com o preco da variante atual.
      if (incoming.dataset.productPrice) root.dataset.productPrice = incoming.dataset.productPrice;
      if (incoming.dataset.productComparePrice) root.dataset.productComparePrice = incoming.dataset.productComparePrice;
    };

    const refreshVariantSection = (variantId) => {
      if (!productUrl || !sectionId || !variantId) return;
      if (String(variantId) === String(lastVariantFetched)) return;
      lastVariantFetched = String(variantId);

      window.clearTimeout(variantTimer);
      variantTimer = window.setTimeout(async () => {
        if (variantRequest) variantRequest.abort();
        variantRequest = new AbortController();
        const url = `${productUrl}?variant=${encodeURIComponent(variantId)}&section_id=${encodeURIComponent(sectionId)}`;
        try {
          const response = await fetch(url, { signal: variantRequest.signal });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          applyVariantSection(await response.text());
        } catch (error) {
          if (error.name !== 'AbortError') console.warn('[product] falha ao renderizar variante', error);
        }
      }, 120);
    };

    function findVariant() {
      if (!form.querySelector('.product-option')) return variants[0] || null;
      return variants.find((variant) => variant.options.every((value, index) => selected[String(index + 1)] === value));
    }

    function updateOptionAvailability() {
      $$('.product-option', form).forEach((group) => {
        const position = group.dataset.optionPosition;
        $$('[data-option-value]', group).forEach((button) => {
          const candidate = { ...selected, [position]: button.dataset.optionValue };
          const available = variants.some((variant) => variant.available && variant.options.every((value, index) => {
            const chosen = candidate[String(index + 1)];
            return chosen == null || chosen === value;
          }));
          button.disabled = !available;
          button.classList.toggle('is-disabled', !available);
          button.setAttribute('aria-disabled', available ? 'false' : 'true');
        });
      });
    }

    function updateVariant() {
      const variant = findVariant();
      activeVariant = variant || null;
      updateOptionAvailability();
      const idInput = $('[data-variant-id]', form);
      const addButton = $('[data-add-to-cart]', form);
      const addLabel = $('[data-add-label]', form);
      const stickyAdd = $('[data-sticky-add]');

      if (!variant) {
        if (idInput) idInput.value = '';
        if (addButton) addButton.disabled = true;
        if (stickyAdd) stickyAdd.disabled = true;
        updateStickySummary();
        if (addLabel) addLabel.textContent = 'Indisponível';
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (addButton) addButton.disabled = !variant.available;
      if (stickyAdd) stickyAdd.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Adicionar ao carrinho' : 'Esgotado';

      const price = $('[data-product-price]', root);
      const compare = $('[data-compare-price]', root);
      const sku = $('[data-product-sku]', root);
      const skuRow = $('[data-product-sku-row]', root);
      if (price) price.textContent = formatMoney(variant.price, window.DropMetaTheme.currency || 'BRL');
      if (compare) {
        compare.hidden = !(variant.compare_at_price > variant.price);
        compare.textContent = variant.compare_at_price ? formatMoney(variant.compare_at_price, window.DropMetaTheme.currency || 'BRL') : '';
      }
      if (sku) sku.textContent = variant.sku || '';
      if (skuRow) skuRow.hidden = !variant.sku;

      updateStickySummary();
      if (variant.featured_media?.id) $('[data-gallery]', root)?.showMedia?.(variant.featured_media.id);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);

      // Depois do feedback imediato, o servidor corrige as regioes de exibicao.
      refreshVariantSection(variant.id);
    }

    function updateStickySummary() {
      const stickyPrice = $('[data-sticky-price]');
      const stickyOption = $('[data-sticky-option]');
      if (!stickyPrice && !stickyOption) return;

      if (!activeVariant) {
        if (stickyPrice) stickyPrice.textContent = '';
        if (stickyOption) stickyOption.textContent = 'Indisponivel';
        return;
      }

      const quantity = normalizeQuantity();
      const optionText = activeVariant.title === 'Default Title' ? '' : activeVariant.title;
      if (stickyPrice) stickyPrice.textContent = formatMoney(activeVariant.price * quantity, window.DropMetaTheme.currency || 'BRL');
      if (stickyOption) stickyOption.textContent = quantity > 1 ? `${quantity} itens${optionText ? ` / ${optionText}` : ''}` : optionText;
    }

    form.addEventListener('submit', async (event) => {
      updateVariant();
      if (!activeVariant?.available) {
        event.preventDefault();
        return;
      }

      if (!useCartDrawer) return;

      event.preventDefault();

      const button = $('[data-add-to-cart]', form);
      const label = $('[data-add-label]', form);
      if (!button || !label) return;
      button.disabled = true;
      const previous = label.textContent;
      label.textContent = 'Adicionando…';

      try {
        await addToCart(new FormData(form));
        label.textContent = 'Adicionado';
      } catch (error) {
        alert(error.message);
        label.textContent = previous;
      } finally {
        window.setTimeout(updateVariant, 700);
      }
    });

    $('[data-sticky-add]')?.addEventListener('click', () => form.requestSubmit());
    updateVariant();
  }

  function initRecommendations() {
    $$('[data-product-recommendations]').forEach(async (container) => {
      if (!container.dataset.url || container.innerHTML.trim()) return;
      try {
        const response = await fetch(container.dataset.url);
        if (!response.ok) return;
        const html = document.createElement('div');
        html.innerHTML = await response.text();
        const replacement = $('[data-product-recommendations]', html);
        if (replacement?.innerHTML.trim()) {
          container.innerHTML = replacement.innerHTML;
          initRails(container);
          initFavorites(container);
        }
      } catch (_) {}
    });
  }

  function initHeroSliders(scope = document) {
    $$('[data-brand-hero]', scope).forEach((root) => {
      if (root.dataset.heroReady === 'true') return;

      const slides = $$('[data-hero-slide]', root);
      const dots = $$('[data-hero-dot]', root);
      if (!slides.length) return;

      const viewport = $('[data-hero-viewport]', root);
      let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

      const setActive = (nextIndex) => {
        activeIndex = clamp(Number(nextIndex) || 0, 0, slides.length - 1);
        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });
        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', String(isActive));
        });
      };

      const showSlide = (nextIndex, behavior = 'smooth') => {
        setActive(nextIndex);
        viewport?.scrollTo({ left: activeIndex * viewport.clientWidth, behavior });
      };

      dots.forEach((dot) => dot.addEventListener('click', () => showSlide(Number(dot.dataset.heroDot))));
      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') showSlide(activeIndex - 1);
        if (event.key === 'ArrowRight') showSlide(activeIndex + 1);
      });

      if (viewport && slides.length > 1) {
        let scrollFrame;
        const syncFromScroll = () => {
          scrollFrame = null;
          if (!viewport.clientWidth) return;
          setActive(Math.round(viewport.scrollLeft / viewport.clientWidth));
        };

        viewport.addEventListener('scroll', () => {
          if (scrollFrame) return;
          scrollFrame = window.requestAnimationFrame(syncFromScroll);
        }, { passive: true });

        window.addEventListener('resize', () => {
          viewport.scrollTo({ left: activeIndex * viewport.clientWidth, behavior: 'auto' });
        }, { passive: true });
      }

      // Troca automatica opcional, ligada pelo editor de temas.
      const autoplayEnabled = root.dataset.heroAutoplay === 'true' && slides.length > 1;
      const autoplayDelay = clamp(Number(root.dataset.heroInterval) || 6, 3, 12) * 1000;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let autoplayTimer = null;

      const stopAutoplay = () => {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      };

      const startAutoplay = () => {
        stopAutoplay();
        if (!autoplayEnabled) return;
        // Respeita quem pediu menos animacao no sistema, e nao move slides
        // enquanto o lojista edita a secao no editor de temas.
        if (reduceMotion.matches || window.Shopify?.designMode) return;
        autoplayTimer = window.setInterval(() => {
          showSlide((activeIndex + 1) % slides.length);
        }, autoplayDelay);
      };

      if (autoplayEnabled) {
        root.addEventListener('mouseenter', stopAutoplay);
        root.addEventListener('mouseleave', startAutoplay);
        root.addEventListener('focusin', stopAutoplay);
        root.addEventListener('focusout', startAutoplay);
        root.addEventListener('pointerdown', stopAutoplay, { passive: true });
        root.addEventListener('pointerup', startAutoplay, { passive: true });
        root.addEventListener('pointercancel', startAutoplay, { passive: true });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) stopAutoplay();
          else startAutoplay();
        });
        reduceMotion.addEventListener?.('change', startAutoplay);
      }

      root.brandHeroShow = showSlide;
      root.dataset.heroReady = 'true';
      showSlide(activeIndex, 'auto');
      startAutoplay();
    });
  }

  function initCartPage() {
    const form = $('[data-cart-page-form]');
    if (!form || form.dataset.cartPageReady) return;
    form.dataset.cartPageReady = 'true';

    let submitTimer;
    const updateCart = () => {
      window.clearTimeout(submitTimer);
      submitTimer = window.setTimeout(() => {
        if (form.dataset.submitting) return;
        form.dataset.submitting = 'true';
        form.setAttribute('aria-busy', 'true');
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }, 180);
    };

    $$('[data-cart-page-minus], [data-cart-page-plus]', form).forEach((button) => button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input');
      const delta = button.hasAttribute('data-cart-page-plus') ? 1 : -1;
      input.value = Math.max(0, Number(input.value || 0) + delta);
      updateCart();
    }));

    $$('input[name="updates[]"]', form).forEach((input) => input.addEventListener('change', () => {
      input.value = Math.max(0, Number(input.value || 0));
      updateCart();
    }));
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closePanel($('[data-menu-drawer]'), $('[data-drawer-scrim]'));
    closeCart();
    closePanel($('[data-filter-drawer]'), $('[data-filter-scrim]'));
  });

  document.addEventListener('DOMContentLoaded', () => {
    initAnnouncementRotator();
    initHeader();
    initHeroSliders();
    initRails();
    initFeaturedProductFilters();
    initFavorites();
    initCart();
    initCollection();
    initProduct();
    initRecommendations();
    initCartPage();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initHeroSliders(event.target);
    initRails(event.target);
    initFeaturedProductFilters(event.target);
  });
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest?.('[data-hero-slide]');
    const root = slide?.closest('[data-brand-hero]');
    if (!slide || !root?.brandHeroShow) return;
    root.brandHeroShow(Number(slide.dataset.heroIndex));
  });
})();
